<template>
  <table
    class="table b-table b-table-stacked-xs table-bordered table-sm bg-white text-uppercase"
  >
    <tbody>
      <tr>
        <td colspan="4">
          <h5 class="text-center"><b>Condições de Saúde</b></h5>
        </td>
      </tr>
      <tr>
        <td colspan="4">
          A FAMÍLIA DECLARA, OU FORNECE INDÍCIOS, DE QUE VIVENCIA SITUAÇÃO DE INSEGURANÇA
          ALIMENTAR DEVIDO À INSUFICIÊNCIA DE ALIMENTOS?
          <b v-if="item.caracteristicas">{{
            formatResultArray(
              item.caracteristicas.ind_risco_inseguranca_alimentar,
              $root.arrays.pergunta
            )
          }}</b>
        </td>
      </tr>
      <tr>
        <td colspan="4">Familiares que fazem uso de:</td>
      </tr>
      <tr>
        <td colspan="4">
          <div v-for="(usuario, index) in item.familiares" :key="index">
            <div
              class="p-0 col-12 mb-3"
              v-if="usuario.saude && usuario.saude.length > 0"
            >
              <table class="table table-bordered">
                <tbody>
                  <tr class="col-12">
                    <td colspan="2">
                      <strong>
                        {{ usuario.nome_completo }}
                      </strong>
                      <br />
                      Idade: {{ usuario.idade }} ano(s)<br />
                    </td>
                  </tr>
                  <tr>
                    <td>Medicamentos Controlados</td>
                    <td>
                      <span
                        v-if="usuario.saude[0].uso_remedio_controlado != null"
                      >
                        {{
                          usuario.saude[0].uso_remedio_controlado == 1
                            ? "Sim"
                            : "Não"
                        }}
                      </span>
                      <span v-else> </span>
                    </td>
                  </tr>
                  <tr>
                    <td>Álcool</td>
                    <td>
                      <span v-if="usuario.saude[0].uso_abusivo_alcool != null">
                        {{
                          usuario.saude[0].uso_abusivo_alcool == 1
                            ? "Sim"
                            : "Não"
                        }}
                      </span>
                      <span v-else> </span>
                    </td>
                  </tr>
                  <tr>
                    <td>Drogas</td>
                    <td>
                      <span v-if="usuario.saude[0].uso_abusivo_drogas != null">
                        {{
                          usuario.saude[0].uso_abusivo_drogas == 1
                            ? "Sim"
                            : "Não"
                        }}
                      </span>
                      <span v-else> </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-else>
              <h4
                class="text-secondary"
                v-if="index == item.familiares.length - 1"
              >
                <i class="mdi mdi-24px mdi-alert-decagram-outline"></i>
                Informações ausentes no prontuário do Usuário.
              </h4>
            </div>
          </div>
        </td>
      </tr>

      <tr>
        <td>Pessoa(s) com Deficiência</td>
      </tr>
      <tr>
        <td colspan="4">
          <div v-for="(familiar, index) in item.familiares" :key="familiar.id">
            <div
              class="p-0 col-12 mb-3"
              v-if="familiar.saude && familiar.saude.length > 0"
            >
              <table class="table table-bordered">
                <tbody>
                  <tr class="col-12">
                    <td colspan="2">
                      <strong>
                        {{ familiar.nome_completo }}
                      </strong>

                      <br />
                      Idade: {{ familiar.idade }} ano(s)<br />
                    </td>
                  </tr>
                  <tr>
                    <td>Tem deficiência?</td>
                    <td>
                      <span v-if="familiar.saude[0].deficiencia != null">
                        {{ familiar.saude[0].deficiencia == 1 ? "Sim" : "Não" }}
                      </span>
                      <span v-else> </span>
                    </td>
                  </tr>
                  <tr v-if="familiar.saude[0].deficiencia == 1">
                    <td>Tipo de deficiência :</td>
                    <td>
                      <span v-if="familiar.saude[0].def_cegueira"
                        >Cegueira,</span
                      >
                      <span v-else-if="familiar.saude[0].def_baixa_visao"
                        >Baixa Visão,</span
                      >
                      <span v-if="familiar.saude[0].def_surdez_servera"
                        >Surdez severa/profunda,</span
                      >
                      <span v-if="familiar.saude[0].def_surdez_leve"
                        >Surdez leve/moderada,</span
                      >
                      <span v-if="familiar.saude[0].def_fisica"
                        >Deficiência física,</span
                      >
                      <span v-if="familiar.saude[0].def_mental_intelectual"
                        >Deficiência mental ou intelectual,</span
                      >
                      <span v-if="familiar.saude[0].def_sindrome_down"
                        >Síndrome de Down,</span
                      >
                      <span
                        v-if="familiar.saude[0].def_transtorno_doenca_mental"
                        >Transtorno/doença mental</span
                      >
                    </td>
                  </tr>
                  <tr v-if="familiar.saude[0].deficiencia == 1">
                    <td>Necessita de cuidados constantes de outra pessoa:</td>
                    <td>
                      <span
                        v-if="
                          familiar.saude[0].ajuda_familia != null ||
                          familiar.saude[0].ajuda_especializada != null ||
                          familiar.saude[0].ajuda_instituicao != null ||
                          familiar.saude[0].ajuda_vizinhos != null ||
                          familiar.saude[0].ajuda_outra_forma != null
                        "
                      >
                        {{
                          familiar.saude[0].ajuda_familia == 1 ||
                          familiar.saude[0].ajuda_especializada == 1 ||
                          familiar.saude[0].ajuda_instituicao == 1 ||
                          familiar.saude[0].ajuda_vizinhos == 1 ||
                          familiar.saude[0].ajuda_outra_forma == 1
                            ? "Sim"
                            : "Não"
                        }}
                      </span>
                      <span v-else> </span>
                    </td>
                  </tr>
                  <tr v-if="familiar.saude[0].deficiencia == 1">
                    <td>Responsável pelo cuidado</td>
                    <td>
                      <span v-if="familiar.saude[0].responsavel_nome">
                        {{ familiar.saude[0].responsavel_nome }}
                      </span>
                      <span v-else> </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-else>
              <h4
                class="text-secondary"
                v-if="index == item.familiares.length - 1"
              >
                <i class="mdi mdi-24px mdi-alert-decagram-outline"></i>
                Informações ausentes no prontuário do Usuário.
              </h4>
            </div>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: ["item"],
  methods: {
    formatResultArray(campo, array) {
      return array.filter((e) => e.id == campo)[0]["value"];
    },
  },
};
</script>

<style lang="scss" scoped></style>
